export default {
  "gamesManage.title": "Games Management",
  "gamesManage.action.details": "Details",
  "gamesManage.action.edit": "Edit",
  "gamesManage.action.enable": "Enable",
  "gamesManage.action.disable": "Disable",
  "gamesManage.tooltip.copy": "Copy {text}",
  "gamesManage.copy.success": "Copied to clipboard",
  "gamesManage.confirm.enable.title": "Enable Game: {gameName}",
  "gamesManage.confirm.disable.title": "Disable Game: {gameName}",
  "gamesManage.confirm.enable.content": "Are you sure you want to enable this game?",
  "gamesManage.confirm.disable.content": "Are you sure you want to disable this game?",
  "gamesManage.confirm.ok": "Confirm",
  "gamesManage.confirm.cancel": "Cancel",
  "gamesManage.batchOpt": "Batch Opt",
  "gamesManage.selectedGames": "You Have Selected {count} Games",
  "gamesManage.addCategoryTagToGames": "Add Category Tag To Games",
  "gamesManage.column.gameId": "GameId",
  "gamesManage.column.gameName": "GameName",
  "gamesManage.column.avatar": "Avatar",
  "gamesManage.column.newAvatar": "NewAvatar",
  "gamesManage.column.gameType": "GameType",
  "gamesManage.column.categoryTags": "CategoryTags",
  "gamesManage.column.displayTag": "DisplayTag",
  "gamesManage.column.providerName": "ProviderName",
  "gamesManage.column.providerShortName": "ProviderShortName",
  "gamesManage.column.demoAvailable": "DemoAvailable",
  "gamesManage.column.gameStatus": "GameStatus",
  "gamesManage.column.providerEnable": "ProviderEnable",
  "gamesManage.column.providerGameId": "ProviderGameId",
  "gamesManage.column.title": "Title",
  "gamesManage.column.keyword": "Keyword",
  "gamesManage.column.createTime": "CreateTime",
  "gamesManage.column.modifyTime": "ModifyTime",
  "gamesManage.column.description": "Description",
  "gamesManage.column.action": "Action",
  "gamesManage.menu.editGameType": "Edit Game Type",
  "gamesManage.menu.addCategoryTag": "Add Category Tag",
};